/* eslint-disable */
// Drupal behavior that controls the display all link on species directory.
(function staffDirecotryScript($, Drupal) {
  Drupal.behaviors.speciesDirecotry = {
    attach(context) {
      // Logic to prevent form submit via enter (only temp until revert)
      $('.staff-directory form').bind('keypress', (e) => {
        if (e.keyCode === 13) {
          e.preventDefault();
          return false;
        }
      });

      $('#staff-directory-submit').unbind().on('click', (e) => {
        e.preventDefault();
        let queryString = window.location.href.split('?')[0];

        if ($('#edit-title').val()) {
          queryString = queryString.concat('?title='.concat($('#edit-title').val()));
          location.href = queryString;
        }
      });

      $('#view-all-staff-directory').unbind().on('click', (e) => {
        e.preventDefault();
        location.href = location.href.split('?')[0].concat('?');
      });

      // NOAA-5280: revert for a later date.
      $('#staff-directory-submit').unbind().on('click', (e) => {
        e.preventDefault();
        let queryString = window.location.href.split('?')[0];
        let parentTermId = document.getElementById('edit-field-division-vocab-target-id--level-1').options[0].getAttribute('data-parent-value');
       
        if ($('#edit-title').val()) {
          queryString = queryString.concat('?title='.concat($('#edit-title').val()));
        }
        if (queryString.indexOf('?') >= 0) {
          if (parentTermId !== $('select[name=field_division_vocab_target_id]').val()) {
            queryString = queryString.concat('&field_division_vocab_target_id='.concat($('select[name=field_division_vocab_target_id]').val()));
          }
        }
        else {
          if (parentTermId === $('select[name=field_division_vocab_target_id]').val()) {
            queryString = location.href.split('?')[0].concat();
          }
          else {
            queryString = queryString.concat('?field_division_vocab_target_id='.concat($('select[name=field_division_vocab_target_id]').val()));
          }
        }
        location.href = queryString;
        // console.log($('select[name=field_division_vocab_target_id]').val());
      });
      $('#view-all-staff-directory').unbind().on('click', (e) => {
        e.preventDefault();
        location.href = location.href.split('?')[0].concat();
      });

        // NOAA-5776: updated id label.

      // Code to hide show all btn, by parm. Added in 5603.
      const urlParams = new URLSearchParams(window.location.search);
      const hasTitle = urlParams.has('title');
      const hasId = urlParams.has('field_division_vocab_target_id');

      if (hasTitle || hasId) {
        $('#view-all-staff-directory').show();
      }
    },
  };

  $(document).ready(function() { 
    $('#move-label').prependTo('.select-wrapper--level-1');
  });

}(jQuery, Drupal));
/*eslint-enable */
